import { section } from './rows';

/** Vehicle: identity of the unit and of this message. */
export const vehicleSections = (view, { t }) => {
	const label = (key) => t(`oemDataModal_cerebrumx_vehicle_${key}`);

	return [
		section('identity', [
			{ key: 'vin', icon: 'tag', label: label('vin'), value: view.vin },
			{ key: 'make', icon: 'directions_car', label: label('make'), value: view.make },
			{ key: 'model', icon: 'directions_car', label: label('model'), value: view.model },
			{ key: 'trim', icon: 'directions_car', label: label('trim'), value: view.trim },
			{ key: 'year', icon: 'calendar_today', label: label('year'), value: view.year },
			{ key: 'oem', icon: 'factory', label: label('oem'), value: t('oemDataModal_cerebrumx_name') },
		]),
		section(
			'message',
			[
				{ key: 'tripId', icon: 'route', label: label('tripId'), value: view.tripId },
				{ key: 'messageId', icon: 'tag', label: label('messageId'), value: view.messageId },
				// Served in a vendor format ("2026-09-02 18:42:21.491027"), shown verbatim.
				{ key: 'sentAt', icon: 'schedule', label: label('sentAt'), value: view.sentAt },
			],
			label('message'),
		),
	];
};
